<div class="layout-menu-container pt-4 flex flex-column justify-content-between">

  <div>

    <div *ngFor="let item of items; let i = index" [class.menu-item-active]="i==1 && router.url=='/'"
         [routerLink]="item.routerLink"
         class="flex align-items-center menu-item cursor-pointer" routerLinkActive="menu-item-active"
         style="padding: 0.7rem 0 0.7rem 1rem">
      <div>
        <i class="pi {{item.icon}}" style="font-size: 17px"></i>
      </div>
      <div class="ml-3" style="font-size: 16px">
        {{item.label}}
      </div>
    </div>
  </div>

  <div class="flex flex-column align-items-center mb-6 pb-6">
    <div class="mb-2">
      <img alt="Zmx Connect" src="zmx-connect.png" width="195px">
    </div>
  </div>

</div>
